import styled from 'styled-components';

export const SparkLabelFontOverride = styled.div`
   label,
   span[class*="spark-text-"]:not([data-component="section-header"] *),
   [data-oid="select-label"],
   .form-label,
   :not(span):not([data-component="section-header"]):not([data-component="section-header"] *){
     font-size: 14px !important;
     font-weight: 400 !important;
   }
`;
